import React from 'react';
import Typography from '@mui/material/Typography';
import { useI18nContext } from '@procore/core-react';
import { useStyles } from './PublicProjectCover.styles';
import JoinTheNetworkButton from '../ButtonsLinks/JoinTheNetworkButton';
import AnalyticsWrappedComponent from '../Analytics/AnalyticsWrappedComponent';
import { useLoginUrl } from '../../helpers/useLoginUrl';

const PublicProjectCover = () => {
  const I18n = useI18nContext();
  const classes = useStyles();
  const loginUrl = useLoginUrl();

  return (
    <div className={classes.container}>
      <Typography variant="h1" className={classes.title}>
        {I18n.t('pages.j.public_project_layout.public_project_cover.title')}
      </Typography>
      <Typography className={classes.description}>
        {I18n.t(
          'pages.j.public_project_layout.public_project_cover.description'
        )}
      </Typography>
      <JoinTheNetworkButton
        className={classes.button}
        dataTrackClick="Public Project"
        section="Public Project"
        text="Join the Network"
        fromGatedPublicProjectPage={true}
      />
      <div className={classes.info}>
        {I18n.t('pages.j.public_project_layout.public_project_cover.info')}
        <AnalyticsWrappedComponent
          componentType="a"
          eventText="Clicked Log In Link"
          eventLabel="Gated Public Project Page"
          className={classes.link}
          data-track-click="Gated Public Project Page, Login"
          href={loginUrl}
          target="_blank"
          rel="noreferrer"
          tabIndex={-1}
        >
          {I18n.t('pages.j.public_project_layout.public_project_cover.login')}
        </AnalyticsWrappedComponent>
      </div>
    </div>
  );
};

export default PublicProjectCover;
